import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { ArrowLink } from "../components/Buttons";
import { SERVICES } from "../data/site";
import { ArrowUpRight } from "lucide-react";

const Services = () => (
  <div data-testid="services-page">
    <PageHeader
      label="What we do"
      lines={["What We Do"]}
      intro="From building a brand foundation to creating campaigns, digital experiences and growth strategies, we provide creative and strategic solutions designed around each client's goals."
    />

    <section className="bg-cream pb-28 md:pb-36">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-2 gap-px bg-dark-text/10 border border-dark-text/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.06}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group relative bg-cream p-8 md:p-12 flex flex-col justify-between min-h-[280px] md:min-h-[340px] hover:bg-bottle-green transition-colors duration-500"
              >
                <div className="flex justify-between items-start">
                  <span className="font-mono text-sm text-dark-text/45 group-hover:text-cream/60 transition-colors duration-500">{s.num}</span>
                  <ArrowUpRight className="w-6 h-6 text-dark-text/40 group-hover:text-cream group-hover:rotate-45 transition-all duration-500" strokeWidth={1.4} />
                </div>
                <div className="mt-10">
                  <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-dark-text group-hover:text-cream transition-colors duration-500">
                    {s.name}
                  </h2>
                  <p className="font-sans text-sm md:text-base text-dark-text/65 group-hover:text-cream/70 leading-relaxed mt-4 max-w-md transition-colors duration-500">
                    {s.short}
                  </p>
                  <span className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase mt-7 text-bottle-green group-hover:text-cream transition-colors duration-500">
                    Explore Service
                    <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Services;
